export const AMENITY_TYPES = {
  BOOKABLE: 0,
  TIME_SLOT: 1,
  INFO_ONLY: 2,
  CAPACITY_LIMITED: 3,
}

export const AMENITY_TYPE_OPTIONS = [
  {
    value: 0,
    label: 'Bookable',
    description: 'Members can book a time range within available hours',
  },
  {
    value: 1,
    label: 'Time Slot',
    description: 'Members choose from predefined time slots',
  },
  {
    value: 2,
    label: 'Info Only',
    description: 'Displayed for information only, no booking required',
  },
  {
    value: 3,
    label: 'Capacity Limited',
    description: 'First-come-first-served with a maximum capacity and check-in',
  },
]

export const AMENITY_TYPE_LABELS = {
  0: 'Bookable',
  1: 'Time Slot',
  2: 'Info Only',
  3: 'Capacity Limited',
}

export const AMENITY_TYPE_BADGE_VARIANTS = {
  0: 'primary',
  1: 'info',
  2: 'default',
  3: 'warning',
}

export const AMENITY_PRESETS = [
  { name: 'Swimming Pool', startTime: '06:00', endTime: '22:00', amenityType: 0, requiresConfirmation: false, maxAdvanceBookingDays: 7 },
  { name: 'Gym', startTime: '05:00', endTime: '23:00', amenityType: 2, requiresConfirmation: false },
  { name: 'BBQ Area', startTime: '10:00', endTime: '22:00', amenityType: 1, requiresConfirmation: true, maxAdvanceBookingDays: 14 },
  { name: 'Event Hall', startTime: '08:00', endTime: '23:00', amenityType: 1, requiresConfirmation: true, maxAdvanceBookingDays: 30, maxBookingsPerMemberPerMonth: 2 },
  { name: 'Tennis Court', startTime: '07:00', endTime: '21:00', amenityType: 1, requiresConfirmation: false, maxAdvanceBookingDays: 7 },
  { name: 'Rooftop Terrace', startTime: '08:00', endTime: '22:00', amenityType: 0, requiresConfirmation: true, maxAdvanceBookingDays: 14 },
  { name: 'Meeting Room', startTime: '08:00', endTime: '20:00', amenityType: 1, requiresConfirmation: false, maxAdvanceBookingDays: 14 },
  { name: 'Kids Play Area', startTime: '08:00', endTime: '20:00', amenityType: 2, requiresConfirmation: false },
  { name: 'Sauna', startTime: '06:00', endTime: '22:00', amenityType: 3, requiresConfirmation: false, maxCapacity: 6, checkInExpiryHours: 1 },
  { name: 'Lounge', startTime: '00:00', endTime: '23:59', amenityType: 2, requiresConfirmation: false },
]
